import { useState } from "react";
import { ActiveFilter } from "../../crawler/crawler.interface";
import './typeaheadSearch.scss';

export interface TypeAheadSearchProps {
    options: string[];
    name: string;
    placeholder?: string;
    defaultValue?: string;
    handleSubmit: (filter: ActiveFilter) => void;
}

export interface TypeAheadState {
    inputText: string;
    suggestedOptions: string[];
}
const TypeAheadSearch = ({ options, name, placeholder = '', defaultValue, handleSubmit }: TypeAheadSearchProps) => {

    const [state, setState] = useState<TypeAheadState>({
        inputText: defaultValue || '',
        suggestedOptions: [...options]
    });

    function handleTypeAheadSubmit() {
        const input = state.inputText;
        if (input.length > 0 && options.indexOf(input) > -1) {
            handleSubmit({ name: name, value: state.inputText });
        }
    }

    function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        let suggestions: string[] = [];
        const value = e.target.value;
        if (value.length > 0) {
            // const regex = new RegExp(`^${value}`, `i`);
            // suggestions = options.sort().filter(v => regex.test(v));
            suggestions = options.sort().filter(v => v.includes(value));
        }

        setState({
            inputText: value,
            suggestedOptions: suggestions
        });
    }

    function suggestionSelected(value: string) {
        setState({
            inputText: value,
            suggestedOptions: []
        });
    }


    function renderOptions() {
        const searchOptions = state.suggestedOptions;
        if (searchOptions.length === 0) {
            return null;
        }
        return (
            <ul className="type-ahead-list">
                {searchOptions.map(opt => <li key={opt} onClick={() => suggestionSelected(opt)}>{opt}</li>)}
            </ul>
        );
    }

    return (
        <div className="type-ahead-wrapper">

            <div className="search-bar">
                <input type="text" onChange={handleInputChange} value={state.inputText} name={name} placeholder={placeholder} />
                <button className="button button--solid" onClick={handleTypeAheadSubmit}>Submit</button>
            </div>
            {renderOptions()}
        </div>
    );
};
export default TypeAheadSearch;